import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import OrderStatusEnum from "@/constants/enums/OrderStatusEnum";
import { enumToStringArray } from "@/utils/enumToArray";
import { HIDDEN_ORDER_STATUSES } from "../const/orderStatuses";

/**
 * The order status options offered as filters: translated, without the hidden statuses, sorted on the
 * translated label so the order matches what the user reads.
 */
export const useOrderStatusOptions = () => {
  const { t, i18n } = useTranslation();

  return useMemo(
    () =>
      enumToStringArray(OrderStatusEnum)
        .filter((entry) => !HIDDEN_ORDER_STATUSES.includes(entry))
        .map((entry) => ({
          value: entry.toString(),
          label: t(`enumerables:orderStatus.${entry}`),
        }))
        .sort((a, b) => a.label.localeCompare(b.label, i18n.language)),
    [t, i18n.language]
  );
};
